import { render } from "@/components/pages/immobilizer/imbRegCentralGatewayType2/IMBRegCentralGatewayType2.html?vue&type=template&id=0d9f59a2&external"
import script from "@/components/pages/immobilizer/imbRegCentralGatewayType2/IMBRegCentralGatewayType2.js?vue&type=script&lang=js&external"
export * from "@/components/pages/immobilizer/imbRegCentralGatewayType2/IMBRegCentralGatewayType2.js?vue&type=script&lang=js&external"

import "@/components/pages/immobilizer/imbRegCentralGatewayType2/IMBRegCentralGatewayType2.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__